import React from 'react';

import {
  CalendarAndClockIcon,
  Card,
  Container,
  Description,
  Name,
  TitleIconContainer,
  TitleSection
} from './AppointmentTypeCard.styled';
import { Button } from 'components/v2/Buttons/Button/Button';
import { AppointmentType } from 'kb-shared/types';
import { useBreakpoints } from 'utilities/useBreakpoints';

interface Props {
  appointmentType: AppointmentType;
  onClick?: () => void;
  footerContent?: React.ReactNode;
}

export const AppointmentTypeCard = ({ appointmentType, onClick, footerContent }: Props) => {
  const { isDesktop } = useBreakpoints();

  return (
    <Container>
      <Card>
        <TitleSection>
          <TitleIconContainer>
            <CalendarAndClockIcon />
          </TitleIconContainer>
          <Name>{appointmentType.name}</Name>
        </TitleSection>
        <Description dangerouslySetInnerHTML={{ __html: appointmentType.description }} />
        {footerContent ||
          (onClick && (
            <Button
              label="Schedule Appointment"
              size={isDesktop ? 'md' : 'lg'}
              category="primary"
              onClick={onClick}
              fullWidth
            />
          ))}
      </Card>
    </Container>
  );
};
